/**
 * @returns 返回给员工管理系统的接口 请求头用
 */

const headers = () => {
  let token = sessionStorage.getItem('token')
  if (!token) {
    const userJson = sessionStorage.getItem('user')
    token = JSON.parse(userJson).token
  }
  return {
    Authorization: token,
    'Club-Id': sessionStorage.getItem('club_id'),
  }
}

export default headers



// WEBPACK FOOTER //
// ./src/api/employeeSystemHeader.js